import React from 'react';
import {ItemDataType} from 'rsuite/cjs/@types/common';
import {SelectPicker} from 'rsuite';

import styles from './OrderBySingle.module.scss';

interface IOrderBySingleProps {
    fieldName: 'monitor' | 'incident';
    /* eslint-disable-next-line no-unused-vars */
    onChange?: (value: Array<{ field: string; direction: 'asc' | 'desc' }>) => void;
    defaultValue?: Array<{ field: string; direction: 'asc' | 'desc' }>;
}

const OrderBySingle: React.FC<IOrderBySingleProps> = ({ fieldName, onChange, defaultValue }) => {
    const directions: ItemDataType<'asc' | 'desc'>[] = [
        { label: 'По возрастанию', value: 'asc' },
        { label: 'По убыванию', value: 'desc' },
    ];

    const currentDirection = defaultValue?.find(item => item.field === fieldName)?.direction;

    const handleChange = (direction: 'asc' | 'desc' | null) => {
        if (onChange) {
            if (direction) {
                // Создаем/обновляем сортировку для текущего поля
                const newOrder = defaultValue
                    ? defaultValue.filter(item => item.field !== fieldName)
                    : [];

                newOrder.push({ field: fieldName, direction });
                onChange(newOrder);
            } else {
                const newOrder = defaultValue
                    ? defaultValue.filter(item => item.field !== fieldName)
                    : [];
                onChange(newOrder);
            }
        }
    };

    return (
        <SelectPicker
            data={directions}
            defaultValue={currentDirection}
            onChange={handleChange}
            searchable={false}
            className={styles.selectPicker}
            placeholder="Сортировка"
            cleanable
        />
    );
};

export default OrderBySingle;